import { ACTIONS, IAppActionInitData } from "app/store/actions"
import { deepEquals } from "app/tools/common"
import { FORECAST_ORDER_NAME, IOrderState } from "order/model"
import { Action, Reducer } from "redux"
import { IOrderActionAddOrUpdate, IOrderActionOpenFormPopup, IOrderActionSetForm, IOrderActionSetList } from "./actions"
import { getDefaultOrderState } from "./state"

export const orderReducer: Reducer<IOrderState, Action> = (
  state: IOrderState | undefined,
  action: Action
): IOrderState => {
  if (!state) {
    state = getDefaultOrderState()
  }
  switch (action.type) {
    case ACTIONS.APP_INIT_DATA: {
      const { orders } = action as IAppActionInitData
      const forecastOrder = orders.find(o => o.name === FORECAST_ORDER_NAME)
      return {
        ...state,
        orders: orders.filter(o => o.name !== FORECAST_ORDER_NAME),
        forecastOrder
      }
    }

    case ACTIONS.ORDER_ADD: {
      const { order } = action as IOrderActionAddOrUpdate
      return {
        ...state,
        orders: [...state.orders, order]
      }
    }

    case ACTIONS.ORDER_UPDATE: {
      const { order } = action as IOrderActionAddOrUpdate
      return {
        ...state,
        orders: state.orders.map(o => (o.id === order.id ? order : o))
      }
    }

    case ACTIONS.ORDER_SET_LIST: {
      const { list } = action as IOrderActionSetList
      return {
        ...state,
        list: {
          ...state.list,
          ...list
        }
      }
    }

    case ACTIONS.ORDER_OPEN_FORM_POPUP: {
      const { form } = action as IOrderActionOpenFormPopup
      return {
        ...state,
        isFormPopupOpened: true,
        form
      }
    }

    case ACTIONS.ORDER_CLOSE_FORM_POPUP: {
      return {
        ...state,
        isFormPopupOpened: false
      }
    }

    case ACTIONS.ORDER_SET_FORM: {
      const { form } = action as IOrderActionSetForm
      return {
        ...state,
        form: {
          ...state.form,
          ...form,
          hasChanged: !deepEquals(form.data, state.form.initialData)
        }
      }
    }

    case ACTIONS.USER_LOGOUT: {
      return getDefaultOrderState()
    }

    default:
      return state
  }
}
